import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { DonorWall } from "@/components/sections/DonorWall";
import { SEO } from "@/lib/seo";

export default function DonorWallPage() {
  return (
    <main>
      <SEO title="Donor Wall" description="A living wall of gratitude — every verified donor who powers Citizen Awareness Foundation's work across India." />
      <PageHeader eyebrow="Gratitude" title="Our Donor Wall" lead="Real people. Real generosity. Every donation here is verified, receipted and audited — and every one of them changed a life." />
      <DonorWall limit={100} />
    </main>
  );
}
